import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthFacade, AuthRoutes } from '@rx-applications/shared/auth/data-access';
import { extractInvitationToken } from '../helpers/extract-invitation-token';
import { isMissingAccountError, isPendingInvitationError } from '../helpers/query-params-error';

export const loginErrorGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const router = inject(Router);
  const authFacade = inject(AuthFacade);

  const error = route.queryParamMap.get('error');
  if (!error) return true;

  if (isMissingAccountError(error)) {
    return router.createUrlTree([`/${AuthRoutes.InvalidUser}`]);
  }

  if (isPendingInvitationError(error)) {
    const token = extractInvitationToken(error);
    if (token) {
      return router.createUrlTree([AuthRoutes.ValidateInvitation], {
        queryParams: { token, idpAuthenticated: true },
      });
    }
  }

  authFacade.ssoError(new Error(error));
  return true;
};
